<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="outline-primary"
        pill
        @click="createAssemblyArea"
        v-if="hasPermission('create_assembly_area')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Add New</span>
      </b-button>
    </div>

    <b-card class="mt-3">
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="Site"
              label-for="site"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <v-select
                label="name"
                v-model="site"
                placeholder="Select Site"
                :options="sites"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Building"
              label-for="building"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <v-select
                label="name"
                v-model="building"
                placeholder="Select Building"
                :options="buildings"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Area Type"
              label-for="area_type"
              class="w-50"
              v-if="searchType.value === 3"
            >
              <v-select
                label="name"
                v-model="area_type"
                placeholder="Select Area Type"
                :options="area_types"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="assembly_areas"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_assembly_area')"
        :per-page="0"
      >
        


        <template #cell(building_data)="row">
          {{
            row.item.building_data ? row.item.building_data.name : ""
          }}
        </template>

        <template #cell(latitude)="row">
          <div v-if="row.item.latitude && row.item.longitude">
            <a :href="`https://www.google.com/maps?q=${row.item.latitude},${row.item.longitude}`" target="_blank">
              Click for Location
            </a>
          </div>
          <div v-else>
            No location available
          </div>
        </template>
        
        <template #cell(manage)="row">
          <b-button
            variant="primary"
            pill
            size="sm"
            class="mr-50"
            @click="editAssemblyArea(row.item)"
            v-if="hasPermission('update_assembly_area')"
          >
            Edit
          </b-button>
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
    <CreateAssemblyAreaModal
      @modalClosed="onModalClosed"
      :key="`create-${createAssemblyAreaModalCount}`"
    />
    <EditAssemblyAreaModal
      :assembly_area="assembly_area"
      @modalClosed="onModalClosed"
      :key="`edit-${editAssemblyAreaModalCount}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateAssemblyAreaModal from "@/components/assembly_area/CreateAssemblyAreaModal.vue";
import EditAssemblyAreaModal from "@/components/assembly_area/EditAssemblyAreaModal.vue";
import util from "@/util.js";
import VueGauge from 'vue-gauge';


export default {
  components: {
    CreateAssemblyAreaModal,
    EditAssemblyAreaModal,
    VueSelectPaginated,
    VueGauge,
  },
  data() {
    return {
      fields: [
        { key: "building_data", label: "Building" },
        { key: "area_type", label: "Area Type" },
        { key: "latitude", label: "Location" },
        { key: "manage", label: "Actions" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      assembly_areas: [],
      assembly_area: null,
      createAssemblyAreaModalCount: 0,
      editAssemblyAreaModalCount: 0,
      searchTypes: [
        { value: 1, name: "Site" },
        { value: 2, name: "Building" },
        { value: 3, name: "Area Type" },
      ],
      searchType: null,
      sites: [],
      site: "",
      buildings: [],
      building: "",
      area_types: [
        { name:"Primary", id:"Primary" },
        { name:"Secondary", id:"Secondary" },
      ],
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();
    const sites =  await this.getSitesDDL();
    this.sites = sites.data;


    const buildings =  await this.getBuildingsDDL();
    this.buildings = buildings.data;

  },
  methods: {
    ...mapActions({
      getAssemblyAreas: "appData/getAssemblyAreas",
      getBuildingsDDL: "appData/getBuildingsDDL",
      getSitesDDL: "appData/getSitesDDL",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.building = "";
            this.area_type = "";
            break;
          case 2:
            this.site = "";
            this.area_type = "";
            break;
          case 3:
            this.site = "";
            this.building = "";
            break;
        }
      } else {
        this.site = "";
        this.building = "";
        this.area_type = "";
      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getAssemblyAreas({
          pageNumber: this.currentPage,      
          site: this.site,      
          building: this.building,      
          area_type: this.area_type,      
        });
        this.assembly_areas = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    createAssemblyArea() {
      this.createAssemblyAreaModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-assembly-area-modal");
      });
    },
    editAssemblyArea(assembly_area) {
      this.assembly_area = assembly_area;
      this.editAssemblyAreaModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-assembly-area-modal");
      });
    },
    async removeAssemblyArea(assembly_area) {
      this.assembly_area = assembly_area;
      try {
        const res = await this.deleteAssemblyArea({
          pk: this.assembly_area.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "Assembly Area deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
